import { ApplicationConfig, isDevMode, mergeApplicationConfig } from '@angular/core';
import { provideStoreDevtools } from '@ngrx/store-devtools';

import { appConfig } from './app.config';

const browserConfig: ApplicationConfig = {
  providers: [
    provideStoreDevtools({
      maxAge: 25,
      logOnly: !isDevMode(),
      autoPause: true,
      trace: false,
      traceLimit: 75,
      connectInZone: true,
    }),
  ],
};

export const config = mergeApplicationConfig(appConfig, browserConfig);
